import React, { useEffect } from 'react';
import { makeStyles, Theme, createStyles, Typography, ButtonBase, Popover } from '@material-ui/core';
import { SketchPicker, BlockPicker } from 'react-color'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
    },
    picker: {
      margin: "2px",
      padding: theme.spacing(1),
      borderRadius: 1,
      height: "2rem",
      width: "2rem",
      boxShadow: theme.shadows[3]
    },
    pickerIn: {
      height: "100%",
      width: "100%",
    }
  }),
);

export interface Props {
    color: string
    colors?: string[] | undefined
    label: string
    type: "Sketch" | "Block"
    onColorChange?: (color: string)=>void | undefined
    onDialogOpen?: (isOpen: boolean)=>void | undefined
}

const ColorPicker = (props: Props) => {

    const classes = useStyles()

    const [colorOpen, setColorOpen] = React.useState(false)
    useEffect(()=>{
        props.onDialogOpen?.(colorOpen)
    }, [colorOpen, props.onDialogOpen] )

    const [colorEl, setColorEl] = React.useState<HTMLButtonElement | null>(null);

    return (
        <div className={classes.root}>
            <ButtonBase 
                className={classes.picker}
                onClick={()=>setColorOpen(true)} 
                ref={(e)=>setColorEl(e)}
            >
                <div className={classes.pickerIn} style={{backgroundColor: props.color}}></div>
            </ButtonBase>
            <Typography variant="body1" component="span">{props.label}</Typography>
            <Popover 
                open={colorOpen}
                onClose={()=>setColorOpen(false)}
                anchorEl={colorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                { props.type === "Sketch" ? (
                    <SketchPicker 
                        disableAlpha 
                        color={props.color}
                        onChange={(color)=>props.onColorChange?.(color.hex)}
                    />
                ) : null}
                { props.type === "Block" ? (
                    <BlockPicker 
                        color={props.color}
                        colors={props.colors}
                        triangle="hide"
                        onChange={(color)=>props.onColorChange?.(color.hex)}
                    />
                ) : null}

            </Popover>
      </div>

    )
}

export default ColorPicker